import ProductPageShell from "@/components/ProductPageShell";
import { Mic } from "lucide-react";

export default function Panels() {
  const visual = (
    <div className="relative aspect-square max-w-sm mx-auto w-full">
      <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-violet-500/15 via-[#0F1D40] to-[#14264F] border border-violet-500/20 overflow-hidden flex items-center justify-center">
        <div className="relative">
          <div className="absolute -inset-10 rounded-full bg-violet-500/10 blur-3xl animate-pulse" />
          <div className="relative w-28 h-28 rounded-full border border-violet-500/40 bg-[#0B1735] flex items-center justify-center">
            <Mic className="w-10 h-10 text-violet-400" />
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <ProductPageShell
      product="panels"
      label="Operon Panels"
      accent="violet"
      kicker="Operon Panels · For event organisers & moderators"
      title="Run better panels. Capture more value."
      lede="A platform for running panel discussions that actually move the field: speaker invites, a live questions pool, audience sign-ups and a searchable recording archive — all in one place."
      bullets={[
        { title: "Speaker & audience in one place", body: "Send structured invitations, confirm attendance and open sign-ups for your audience without juggling three tools." },
        { title: "Live questions pool", body: "Attendees submit and upvote questions in real time, so your moderator always has the right next question ready." },
        { title: "Searchable recording archive", body: "Every past panel becomes a reusable asset — watch, search and share the moments that mattered." },
      ]}
      visual={visual}
    />
  );
}
